/**
 * Build-time configuration. Vite injects VITE_* env vars at build time;
 * we surface them through a typed `env` object so the rest of the app
 * doesn't have to know about `import.meta.env` shape.
 *
 * Values may be empty during the M5.1 scaffold phase (before the platform
 * stack is deployed). `isConfigured` lets callers decide whether to skip
 * setup work that would otherwise crash. Once the backend is up, the
 * deploy workflow injects real values via `vars.VITE_*` and `isConfigured`
 * returns true.
 */

export const env = {
  /** Cognito User Pool ID, e.g. us-west-2_AbCdEfGhI */
  userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
  /** Cognito User Pool web client ID (no secret) */
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  /** AWS region — defaults to us-west-2 */
  awsRegion: import.meta.env.VITE_AWS_REGION ?? 'us-west-2',
  /** GA4 measurement ID. Tracking is no-op when unset. */
  gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
} as const;

/** True once Cognito + API config are populated. */
export function isConfigured(): boolean {
  return Boolean(env.userPoolId && env.userPoolClientId);
}
